import { Button } from "newui/components/Button";

export interface QuestionsErrorProps {
	onRetry: () => void;
}

export const QuestionsError = ({ onRetry }: QuestionsErrorProps) => (
	<div
		className="flex flex-col items-center gap-3 py-12 text-center"
		data-testid="pre-compliance-questions-error"
	>
		<p className="text-sm text-red-600">
			We couldn&apos;t load the compliance questions.
		</p>
		<Button
			btntype="secondary"
			onClick={onRetry}
			data-testid="pre-compliance-questions-retry-btn"
		>
			Try again
		</Button>
	</div>
);
